import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'icon-whatsapp',
  template: `
    <ng-template #template>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 448 512" fill="currentColor" [ngClass]="class">
        <path
          d="M380.9 97.1C339 55.1 283.1 32 224.8 32
             103.3 32 3.4 131.9 3.4 253.4c0 44.6 11.6 88 33.8
             126.2L0 480l103.6-36.3c36.2 19.9 77.2 30.5 119.1
             30.5 121.5 0 221.4-99.9 221.4-221.4 0-58.2-23.2-113.9-63.2-155.7zM224.8
             438c-37.3 0-74-10.1-106.1-29.2l-7.6-4.5-61.4 21.6
             21.2-59.7-5-7.9C46.2 319.7 36.8 287.3 36.8
             253.4c0-103.6 84.3-187.8 187.9-187.8 50.2 0 97.3
             19.6 132.9 55.2 35.6 35.7 55.2 82.8 55.2
             132.9.1 103.6-84.2 187.8-187.9 187.8zm101.6-138.2c-5.5-2.7-32.5-16-37.6-17.8-5.1-1.9-8.9-2.7-12.7
             2.7s-14.6 17.8-17.9 21.5c-3.2 3.7-6.6 4.1-12.1
             1.4-5.5-2.7-23.3-8.6-44.4-27.5-16.4-14.7-27.4-32.9-30.6-38.4-3.2-5.5-.3-8.5
             2.4-11.2 2.5-2.6 5.5-6.7 8.2-10.1 2.7-3.5 3.6-5.9
             5.5-9.7 1.8-3.7.9-7-0.4-9.7-1.4-2.7-12.7-30.6-17.4-41.9-4.6-11.1-9.3-9.6-12.7-9.7-3.2-.1-7-.1-10.7-.1s-9.8
             1.4-14.9 7c-5.1 5.6-19.7 19.3-19.7 47.2s20.2 54.7
             23 58.5c2.7 3.7 39.8 60.7 96.6 85.2 13.5 5.8
             24 9.2 32.2 11.7 13.5 4.3 25.8 3.7 35.5
             2.2 10.8-1.6 32.5-13.3 37.1-26.2 4.6-12.8
             4.6-23.8 3.2-26.2-1.3-2.3-5.1-3.7-10.6-6.5z"
        />
      </svg>
    </ng-template>
  `,
})
export class IconWhatsAppComponent {
  @Input() class: string = '';
  @Input() width: string = '24';
  @Input() height: string = '24';

  @ViewChild('template', { static: true }) template: any;
  constructor(private viewContainerRef: ViewContainerRef) {
    // do nothing
  }
  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
    this.viewContainerRef.element.nativeElement.remove();
  }
}
